import { defineStore, createPinia } from 'pinia'

const pinia = createPinia();

interface State {
  lastVisitedTabs: string;
  testId: number;
  modalParameters: {
    title: string;
    message: string;
    state: boolean;
    action: string;
  }
}

/* eslint-disable */

export const useMainStore = defineStore("main", {
  state: () => {
    if (localStorage.getItem("piniaState")) {
      // @ts-ignore
      if (JSON.parse(localStorage.getItem("piniaState")).main) {
        // @ts-ignore
        return { lastVisitedTabs: JSON.parse(localStorage.getItem("piniaState")).main.lastVisitedTabs, testId: JSON.parse(localStorage.getItem("piniaState")).main.testId, modalParameters: JSON.parse(localStorage.getItem("piniaState")).main.modalParameters };
      }
      else {
        return {
          lastVisitedTabs: "users-table-tab",
          testId: null,
          modalParameters: {
            title: "",
            message: "",
            state: false,
            currentRoute: ""
          }
        }
      }
    } else {
      return {
        lastVisitedTabs: "users-table-tab",
        testId: null,
        modalParameters: {
          title: "",
          message: "",
          state: false,
          action: ""
        }
      }
    }
  },
  getters: {
  },
  actions: {
    changeTab(tab: string) {
      this.lastVisitedTabs = tab
    },

    settestId(id: number) {
      this.testId = id
    },

    setModalParameters({ title, message, state, action }: { title: string, message: string, state: boolean, action: string }) {
      this.modalParameters = {
        title: title,
        message: message,
        state: state,
        action: action
      }
    },

    initializeStore(): void {
      const cachedState: string | null = localStorage.getItem("piniaState");
      // eslint-disable-next-line
      //@ts-ignore
      const parsedState = JSON.parse(cachedState);

      pinia.state.value = parsedState;
    },

    $reset() {
      this.lastVisitedTabs = "users-table-tab";
      this.testId = null;
      this.modalParameters = {
        title: "",
        message: "",
        state: false,
        currentRoute: ""
      }
    }
  }
})

